module.exports = __webpack_public_path__ + "static/media/Tsugaeda.c908651f.png";